module.exports = __webpack_public_path__ + "static/img/1_1.a5200cba.jpg";